import {Stack} from "@mui/material";
import {DryMatterProductionCumulativeChart} from "./charts/DryMatterProductionCumulativeChart";
import {PercentVegetationCoverChart} from "./charts/PercentVegetationCoverChart";
import {LeafNitrogenChart} from "./charts/LeafNitrogenChart";
import {NetCarbonSupplyInSoilChart} from "./charts/NetCarbonSupplyInSoilChart";
import {FieldResult} from "../../types/domain/fieldResult";
import {useLoadableValueOrDefault} from "../../hooks/jotaiHooks";
import {UserPreferences} from "../../types/domain/user";
import {authenticatedUserPreferencesLoadable} from "../../store/authenticatedUserStore";

export interface Props {
    data: FieldResult[];
}

export const FieldVegetationInsightsView: React.FC<Props> = ({data}) => {
    const userPreferences = useLoadableValueOrDefault<UserPreferences | undefined>(
        authenticatedUserPreferencesLoadable,
        undefined,
    );
    const isAdvanced = userPreferences?.enabledAdvancedFeatures;

    return (
        <Stack direction="column" gap="1.25rem">
            <DryMatterProductionCumulativeChart data={data} />
            <PercentVegetationCoverChart data={data} />
            {isAdvanced && <LeafNitrogenChart data={data} />}
            {isAdvanced && <NetCarbonSupplyInSoilChart data={data} />}
        </Stack>
    );
};
